/** Грейд сдаваемого устройства. "A+" приходит от API, но приводится к "Q" */
export type Grade = "Q" | "A" | "B" | "C" | "D" | "E" | "F" | "N";

const GRADE_ALIASES: Record<string, Grade> = {
    "A+": "Q",
};

export function normalizeGrade(grade: string): Grade {
    const upperCased = grade.toUpperCase();
    return GRADE_ALIASES[upperCased] ?? (upperCased as Grade);
}
